import { Component, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { AuthenticationService, TokenInterface } from '../services';

export type CanDeactivateComponent = Component & {
  canDeactivate(): Observable<boolean>;
};

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<CanDeactivateComponent> {

  constructor(private authenticationService: AuthenticationService) { }

  canDeactivate(
    component: CanDeactivateComponent
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authenticationService.getToken().pipe(
      first(),
      switchMap((token: TokenInterface) => (!!token?.value && component && component.canDeactivate) ? component.canDeactivate() : of(true))
    );
  }
}
